export const getHomeGreeting = (hour) => {
  if (hour >= 5 && hour < 12) return 'Goedemorgen';
  if (hour >= 12 && hour < 18) return 'Goedemiddag';
  return 'Goedenavond';
};

export const formatHomeDate = (value = new Date()) => new Intl.DateTimeFormat('nl-NL', {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
}).format(value);

export const groupHomeItems = (items = []) => ({
  today: items.filter((item) => item.category === 'today'),
  attention: items.filter((item) => item.category === 'attention'),
  planning: items.filter((item) => item.category === 'planning').slice(0, 5),
  organization_attention: items.filter((item) => item.category === 'organization_attention'),
  zoea_development: items.filter((item) => item.category === 'zoea_development'),
});
